import { render } from "./UncodedHeader.vue?vue&type=template&id=6838f1b6"
import script from "./UncodedHeader.vue?vue&type=script&lang=js"
export * from "./UncodedHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__